import React from 'react';

type FillColor = string;
type ClassName = string;

interface IProps {
  fillColor: FillColor;
  className: ClassName;
}

const defaultProps = {
  className: '',
  fillColor: '#53585E',
};

const FacebookLogoIcon = ({
  fillColor,
  className,
}: IProps): React.ReactElement<React.ReactNode> => (
  <svg
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-labelledby="facebookLogo"
    aria-hidden="true"
  >
    <title id="facebookLogo">Facebook Logo</title>
    <g fill="none" fillRule="evenodd">
      <g fill={fillColor}>
        <path d="M0.750375,0 C0.3358125,0 0,0.3358125 0,0.7498125 L0,17.2501875 C0,17.6641875 0.3358125,18 0.750375,18 L9.5625,18 L9.5625,11.25 L7.3125,11.25 L7.3125,8.4375 L9.5625,8.4375 L9.5625,6.1875 C9.5625,3.8626875 11.0345625,2.7185625 13.1085,2.7185625 C14.101875,2.7185625 14.95575,2.7928125 15.204375,2.8254375 L15.204375,5.2554375 L13.7660625,5.256 C12.63825,5.256 12.375,5.7920625 12.375,6.5784375 L12.375,8.4375 L15.1875,8.4375 L14.625,11.25 L12.375,11.25 L12.42,18 L17.2501875,18 C17.6641875,18 18,17.6641875 18,17.2501875 L18,0.7498125 C18,0.3358125 17.6641875,0 17.2501875,0 L0.750375,0 Z" />
      </g>
    </g>
  </svg>
);

FacebookLogoIcon.defaultProps = defaultProps;

export { FacebookLogoIcon };
